import {ACTION_SET_SELECTED_UNIT, ACTION_SET_UNITS, ACTION_SET_UPDATE_UNIT} from "./constants";
import {getUnitID} from "../components/unit/utils";

/**
 * Initial/ Fallback state
 */
const INITIAL_STATE = {
    units: {},
    selectedUnit: null
};


/* -----------------    Actions     ------------------ */
/**
 * Action to set the {@code units} in the store based on the specified action
 */
const applySetUnits = (state, action) => ({
    ...state,
    units: action.units
});

/**
 * Action to update or set a {@code unit} onto the state's {@code units}
 */
const applyUpdateUnit = (state, action) => ({
    ...state,
    units: {...state.units, ...action.unit},
    selectedUnit: (state.selectedUnit && getUnitID(state.selectedUnit) === getUnitID(action.unit))
        ? action.unit
        : state.selectedUnit
});

/**
 * Action to set the {@code selectedUnit} in the store based on the specified action
 */
const applySetSelectedUnitDropdown = (state, action) => ({
    ...state,
    selectedUnit: action.selectedUnit
});


/* -----------------    Session Reducer     ------------------ */
/**
 * Session Reducer that manages all actions related to the store
 */
function unitsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTION_SET_UNITS:
            return applySetUnits(state, action);
        case ACTION_SET_UPDATE_UNIT:
            return applyUpdateUnit(state, action);
        case ACTION_SET_SELECTED_UNIT:
            return applySetSelectedUnitDropdown(state, action);
        default:
            return state;
    }
}

export default unitsReducer;



// WEBPACK FOOTER //
// ./src/reducers/unit.js